export default "__VITE_ASSET__f2308cbb__"